import React from 'react';

import CrossBorder from './CrossBorder';

const Transfer = () => {
  return (
    <>
      <CrossBorder />
    </>
  );
};

export default Transfer;
